<main class="h-screen w-screen flex items-center justify-center">
    <section class="w-1/4 h-1/4 flex items-center justify-center rounded-lg border border-red-300 bg-white text-gray-600">
        Login fallido!
    </section>
</main>